import { usePathname } from "next/navigation"
import { useEffect, useState } from "react"

import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { useJobAdsFetchContext } from "@/modules/jobAds/client/hooks/useJobAdsFetchContext"

const JOB_OFFERS_TAB_PATTERN = /\/job-offers$/

export const useGetTitleSuffix = (): string => {
  const { t } = useTranslation(["companies_client"])
  const pathname = usePathname()
  const [titleSuffix, setTitleSuffix] = useState("")
  const { dataJobAds } = useJobAdsFetchContext()
  const dataJobAdsCount = dataJobAds?.totalSize || 0

  useEffect(() => {
    let suffix
    if (JOB_OFFERS_TAB_PATTERN.test(pathname)) {
      suffix = t("companies_client.meta.title.suffix.jobOffers", { count: dataJobAdsCount })
    } else {
      suffix = t("companies_client.meta.title.suffix.informations")
    }
    setTitleSuffix(suffix)
  }, [dataJobAdsCount, pathname, t])

  return titleSuffix
}
